import { ChangeDetectorRef } from '@angular/core';
import { FormGroup, NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { FormMode, MessageTypes } from 'app/shared/model/enums';
import { CommonService } from 'app/shared/services/common.service';
import { AdvMessageService } from 'app/shared/services/message.service';
import { Observable, Subscription } from 'rxjs';
import { SideBarService } from '../services/side-bar.service';
import { BaseComponent } from './base-component';


export abstract class SimpleBaseForm extends BaseComponent {

  constructor(messageService: AdvMessageService, localizationService: LocalizationService,
    protected route: ActivatedRoute, protected sideBarService: SideBarService, protected cdr: ChangeDetectorRef, protected router: Router) {
    super(messageService, localizationService)
    this.sideBarService.setContentDeActivate(this.canDeactivate.bind(this))
  }

  protected abstract get form(): NgForm;
  protected abstract save(args?: any): Observable<any>;

  protected subscriptions: Subscription = new Subscription();

  protected id: number

  onDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  saveCompleted() { }


  //#region BaseComponent implementation
  isDirty() {
    return this.form?.form.dirty;
  }
  //#endregion


  markAsDirty() {
    if (this.form?.form) {
      this.form.form.markAsDirty();
    }
  }

  saveForm(args?: any) {
    if (!this.isValid()) {
      this.messageService.errorMessage('ERRORS.CANNOT_SAVE_INVALID_FORM', true)
      return;
    }
    else
      if (!this.isDirty()) {
        this.messageService.showMessage(MessageTypes.warn, null, 'ERRORS.NO_CHANGES_TO_SAVE', true)
        return;
      }
      else {
        this.save(args)?.subscribe((id) => {
          if (!id) { return; }
           
          this.id = id;
          this.messageService.successMessage('GENERAL.MESSAGES.SAVED_SUCCESSFULY', true);
          this.form.form.markAsPristine();
          this.form.form.markAsUntouched();
          this.saveCompleted();

        });
      }
  }
  
  protected isValid() {
    if (this.form && this.form.controls && !this.form.valid) {
      this.showErrors();
      return false;
    }
    return true;
  }
  
  private showErrors() {
    if (this.form && this.form.controls) {
      Object.keys(this.form.controls).forEach(key => {
        this.form.controls[key].markAsDirty();
        this.form.controls[key].markAsTouched();
      });
    }
  }
  
}
